import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const dropdownList = {
	DphSzbOzn: [],
	ProvozovnaId: [],
	SkladpneuOzn: [],
	StredNaklOzn: [],
};

const edit = {
	ZaznamId: null as number | null,
	ZakazkaId: null as number | null,
	PneuskladId: null as number | null,
	Text: null as string | null,
	Pc: null as number | null,
	Sleva: null as number | null,
	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	VstupProvId: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	EditPracId: null as Date | null,
	PracovnikId: null as number | null,
	EditDat: null as Date | null,
	SkladpneuOzn: null as number | null,
	DphSzbOzn: null as number | null,
	Poznamka2dd: null as string | null,
	Skladmistop: null as string | null,

	SkladmistopIdPopis: null as string | null,
	SkladmistopIdText: null as string | null,
	StrednaklOznText: null as string | null,
	VstupPracIdText: null as string | null,
	EditPracIdText: null as string | null,
	PracovnikIdText: null as string | null,
	PracovnikOsobniCis: null as number | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {
		SkladmistopId: null as number | null,
		IsZakaznikChk: true as boolean,
		IsVozidloChk: true as boolean,
		disableSkladPneuBtn: false,
		disableAddBtn: true,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[editMutations.PROVOZOVNA_CHANGE](state) {
			state.edit.StrednaklOzn = null;
			state.edit.StrednaklOznText = null;
		},
		[editMutations.SKLAD_MISTO_SELECT_MAPPER](state, { data }) {
			state.localState.SkladmistopId = data.id;
			state.edit.Skladmistop = data.value;
			state.edit.SkladmistopIdText = data.value;
			state.edit.SkladmistopIdPopis = data.text;
		},
		[editMutations.NAKLAD_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
		[editMutations.PRACOVNIK_SELECT_MAPPER](state, { data }) {
			state.edit.PracovnikId = data.value;
			state.edit.PracovnikIdText = data.jmeno || data.text ? `${data.text} ${data.jmeno}` : null;
			state.edit.PracovnikOsobniCis = data.osobniCis;
			if (data.value > 0) {
				state.edit.ProvozovnaId = data.provozovnaId;
				state.edit.StrednaklOznText = data.strednaklOznText;
				state.edit.StrednaklOzn = data.strednaklOzn;
			}
		},
		[editMutations.PNEU_SKLAD_SELECT](state, data) {
			state.edit.Text = data.Text;
			state.edit.PneuskladId = data.ZaznamId;
			state.localState.SkladmistopId = data.SkladmistopId;
			state.edit.SkladmistopIdText = data.SkladmistopIdText;
			state.edit.Skladmistop = data.SkladmistopIdText;
			state.edit.Pc = data.Pc;
		},
	},
	props: {
		mode: null,
		filter: {
			ZakazkaId: null as number | null,
		},
		ZakaznikId: null as number | null,
		VozidloId: null as number | null,
	},
});
